import axios from 'axios'
import { firestore } from 'src/contexts/FirebaseContext'
import { MICROSOFT_CONFIG } from 'src/config'


export function setMSCredentials({userId, data, onResolve, onReject}) {
    return async () => {
        try {
            // console.log('init', data)
            const {accessToken, expiresOn, tenantId, uniqueId, scopes = []} = data;

            // const snap = await axios.get("${MICROSOFT_CONFIG.GRAPH_URL}/calendars", {
            //     headers: {
            //         Authorization: `Bearer ${accessToken}`
            //     }
            // })
            await firestore.collection('users').doc(userId).set({
                microsoftCredential: {
                    accessToken,
                    expiresOn,
                    tenantId,
                    uniqueId,
                    scopes
                }
            }, {merge: true,})

            onResolve()

        } catch (e) {
            //console.log(e)
            onReject && onReject(e)
        }
    }
}


export function setMSUnlinkCredentials({userId, onResolve, onReject}) {
    return async () => {
        try {

            await firestore.collection('users').doc(userId).set({microsoftCredential: null}, {merge: true,})

            onResolve()

        } catch (e) {
            //console.log(e)
            onReject && onReject(e)
        }
    }
}


export function getMSAllCalendar({accessToken, onResolve, onReject}) {
    return async () => {
        try {
            if(!accessToken) return  onReject && onReject(`accessToken == $accessToken`)

            const snap = await axios.get(`${MICROSOFT_CONFIG.GRAPH_URL}/calendars`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })

            onResolve(snap.data?.value || [])

        } catch (e) {
            //console.log(e)
            onReject && onReject(e)
        }
    }
}

export function getMSAllCalendarEvents({accessToken, onResolve, onReject}) {
    return async () => {
        try {

            if(!accessToken) return  onReject && onReject(`accessToken == $accessToken`)

            const snap = await axios.get(`${MICROSOFT_CONFIG.GRAPH_URL}/events?$select=subject,body,bodyPreview,organizer,attendees,start,end,location`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })

            onResolve(snap.data?.value || [])

        } catch (e) {
            //console.log(e)
            onReject && onReject(e)
        }
    }
}

export function createMSEvent({accessToken, calendarId, event, onResolve, onReject}) {
    return async () => {
        try {
            const snap = await axios.post(`${MICROSOFT_CONFIG.GRAPH_URL}/calendars/${calendarId}/events`,
                event,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-type": "application/json",
                    },
                })

            onResolve(snap.data?.value)

        } catch (e) {
            //console.log(e)
            onReject && onReject(e)
        }
    }
}

export function editMSEvent({accessToken, calendarId, event, onResolve, onReject}) {
    return async () => {
        try {
            const {id, ...rest} = event;

            const snap = await axios.patch(`${MICROSOFT_CONFIG.GRAPH_URL}/calendars/${calendarId}/events/${id}`,
                rest,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-type": "application/json",
                    },
                })
            //console.log(snap.data)

            onResolve(snap.data?.value)

        } catch (e) {
            //console.log(e)
            onReject && onReject(e)
        }
    }
}

export function deleteMSEvent({accessToken, calendarId, eventId, onResolve, onReject}) {
    return async () => {
        try {

            const snap = await axios.delete(`${MICROSOFT_CONFIG.GRAPH_URL}/calendars/${calendarId}/events/${eventId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-type": "application/json",
                    },
                })
            //console.log(snap.data)

            onResolve(snap.data?.value)

        } catch (e) {
            //console.log(e)
            onReject && onReject(e)
        }
    }
}